import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useCategoryForm } from "./contexts/CategoryFormContext";

export default function CategoryFormPage() {
  const [searchParams] = useSearchParams();
  const updateCategoryId = searchParams.get("id");

  const { data, isLoading, error, isDone, handleData, handleCreate, handleUpdate, handleDelete, image, setImage, fetchData } = useCategoryForm();

  useEffect(() => {
    if (updateCategoryId) {
      fetchData(updateCategoryId);
    }
  }, [updateCategoryId]);

  return (
    <main className="container mt-4">
      <div className="d-flex align-items-center justify-content-center gap-3">
        {updateCategoryId ? (
          <h3 className="text-white bg-warning px-3 py-2 rounded-pill text-uppercase fw-bold small">
            Update
          </h3>
        ) : (
          <h3 className="text-white bg-success px-3 py-2 rounded-pill text-uppercase fw-bold small">
            Create
          </h3>
        )}
        <h1 className="fw-bold h4">Category | Form</h1>
      </div>

      <section className="row justify-content-center">
        <div className="w-75">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              if (updateCategoryId) {
                handleUpdate(updateCategoryId);
              } else {
                handleCreate();
              }
            }}
            className="p-4 bg-light rounded shadow-sm"
          >
            {/* Category Name */}
            <div className="mb-3">
              <label className="form-label">
                Category Name <span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                placeholder="Enter Category Name"
                type="text"
                onChange={(e) => handleData("name", e.target.value)}
                value={data?.name}
                required
              />
            </div>

            {/* Category Slug */}
            <div className="mb-3">
              <label className="form-label">
                Category Slug <span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                placeholder="Enter Category Slug"
                type="text"
                onChange={(e) => handleData("slug", e.target.value)}
                value={data?.slug}
                required
              />
            </div>

            {/* Image Preview */}
            {data?.iconURL && (
              <div className="mb-3 text-center">
                <img
                  className="img-thumbnail"
                  src={data?.iconURL}
                  alt="Category Icon"
                  width="150"
                />
              </div>
            )}
            {image && (
              <div className="mb-3 text-center">
                <img
                  className="img-thumbnail"
                  src={URL.createObjectURL(image)}
                  alt="Preview"
                  width="150"
                />
              </div>
            )}

            {/* Image Upload */}
            <div className="mb-3">
              <label className="form-label">Image</label>
              <input
                className="form-control"
                type="file"
                accept="image/*"
                onChange={(e) => setImage(e.target.files[0])}
              />
            </div>

            {/* Error Message */}
            {error && <p className="text-danger">{error}</p>}

            {/* Submit Button */}
            <button
              type="submit"
              disabled={isLoading}
              className="btn btn-primary w-100"
            >
              {isLoading
                ? "Loading..."
                : updateCategoryId
                ? "Update"
                : "Create"}
            </button>

            {/* Delete Button */}
            {updateCategoryId && (
              <button
                onClick={(e) => {
                  e.preventDefault();
                  handleDelete(updateCategoryId);
                }}
                disabled={isLoading}
                className="btn btn-danger w-100 mt-2"
              >
                Delete
              </button>
            )}

            {/* Success Message */}
            {isDone && (
              <h3 className="text-success text-center mt-3 fw-bold">
                Successfully {updateCategoryId ? "Updated" : "Created"}!
              </h3>
            )}
          </form>
        </div>
      </section>
    </main>
  );
}
